import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import EditableRichText from '../../../../../src/web/containers/EditableRichText';
import LeadFormContainer from '../../../../../src/web/containers/LeadFormContainer';
import styles from './styles.scss';

const propTypes = {
  popupHeaderText: PropTypes.string.isRequired,
  popupBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  popupIncludeForm: PropTypes.bool.isRequired,
  popupButtonText: PropTypes.string.isRequired,
  settingsLeadSource: PropTypes.string,
  onLeadFormSubmitted: PropTypes.func,
  sourceName: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
};

const defaultProps = {
  settingsLeadSource: undefined,
  onLeadFormSubmitted: undefined,
  sourceName: undefined,
};

const attrs = [
  'popupHeaderText',
  'popupBodyContent',
  'popupIncludeForm',
  'popupButtonText',
  'settingsLeadSource',
  'onLeadFormSubmitted',
  'sourceName',
];

const PopupBody = ({
  popupHeaderText,
  popupBodyContent,
  popupIncludeForm,
  popupButtonText,
  settingsLeadSource,
  onLeadFormSubmitted,
}) => (
  <div>
    <Row>
      <Col xs={12}>
        <div className={`color-primary-foreground ${styles.popupHeader}`}>
          {popupHeaderText}
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <EditableRichText
          editorKey="popup-body-text"
          rawContentState={popupBodyContent}
        />
      </Col>
    </Row>
    <Row className={styles.popupForm}>
      <Col xs={12}>
        {popupIncludeForm
          && (
          <LeadFormContainer
            submitText={popupButtonText}
            onSubmitted={onLeadFormSubmitted}
            sourceName={settingsLeadSource}
          />
          )
        }
      </Col>
    </Row>
  </div>
);

PopupBody.propTypes = propTypes;
PopupBody.defaultProps = defaultProps;
PopupBody.attrs = attrs;

export default PopupBody;
